import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/app/service/[categoryName]/[productName]/Product.js");
